import React from "react";
import Survey from "./Survey";
import "../App.css";

export default function SAdol() {
  return (
    <div>
      <Survey />
    </div>
  );
}
